<button mat-raised-button (click)="showHelp()" *ngIf="displayHelp && helpAlias">
    <mat-icon svgIcon="help"></mat-icon>
    <span>{{ 'generic.getting_started' | translate}}</span>
</button>
